import { __assign } from "tslib";
import React from 'react';
import { Paper } from '../../Paper';
import { Popper } from '../../Popper';
import { useStyles } from './ListboxDropdown.FloatingDropdown.styles';
export var FloatingDropdown = function (props) {
    var anchorEl = props.anchorEl, isOpen = props.isOpen, PopperProps = props.PopperProps, children = props.children;
    var classes = useStyles();
    if (anchorEl === null) {
        return null;
    }
    return (React.createElement(Popper, __assign({ role: "presentation", disablePortal: true, modifiers: {
            flip: {
                enabled: true,
            },
            preventOverflow: {
                enabled: false,
                boundariesElement: 'view',
            },
            hide: {
                enabled: false,
            },
        }, anchorEl: anchorEl, open: isOpen, style: { width: anchorEl.clientWidth } }, PopperProps),
        React.createElement(Paper, { variant: "dropdown", className: classes.paper }, children)));
};
//# sourceMappingURL=ListboxDropdown.FloatingDropdown.js.map